import axios from "axios"
import store from "../store"
import config from "../../config.json"
import AppLocalStorage from "./app-local-storage"

let api = config.client.api

if (window.location.toString().toLowerCase().includes(config.client.bkp)) {
  api = config.client.apiBkp
}

axios.defaults.baseURL = api
axios.publicURL = false

axios.interceptors.request.use((request) => {

  if (!store.state.authToken || axios.publicURL)
    return request
  
  request.headers.common["auth-token"] = store.state.authToken

  return request

}, (error) => Promise.reject(error))

axios.interceptors.response.use((response) => response.data, (error) => {

  if (error.response && error.response.data && error.response.data.errorCode == 401) {    

    Promise.resolve()

    AppLocalStorage.clear()
    location.reload()    

  }  else {

    return Promise.reject(error)
  }  
})

export default axios